export const getMeetingColumns = (translate) => {
  return [
    {
      dataField: 'date',
      type: 'date',
      text: translate('Date'),
      sort: true,
      sortValue: (cell, row) => {
        return row.dateValue;
      },
      headerStyle: () => {
        return { width: '10%' };
      },
    },
    {
      dataField: 'agenda',
      type: 'string',
      text: translate('Agenda'),
      sort: true,
      headerStyle: () => {
        return { width: '60%' };
      },
    },
    {
      dataField: 'minutesLong',
      type: 'number',
      text: translate('Minutes Long'),
      sort: true,
      headerStyle: () => {
        return { width: '5%', textAlign: 'center' };
      },
      style: () => {
        return { textAlign: 'center' };
      },
    },
    {
      dataField: 'tasks',
      type: 'number',
      text: translate('Tasks'),
      sort: true,
      headerStyle: () => {
        return { width: '5%', textAlign: 'center' };
      },
      style: () => {
        return { textAlign: 'center' };
      },
    },
    {
      dataField: 'action',
      searchable: false,
      text: translate('Action'),
      headerStyle: () => {
        return { width: '20%', textAlign: 'center' };
      },
    },
  ];
};
